import { Alert } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

/**
 * Shared "Premium required" notice for data calls behind the backend
 * `requirePremiumTier` gate (which returns HTTP 402 for a non-premium / expired
 * trial org). Pair with `isPremiumRequiredError` from `@/lib/premium`.
 *
 * `PremiumFeatureGate` handles the group-home-admin case before the call is
 * made, but it deliberately falls through to children for non-admins (who
 * cannot read the subscription). For them the call still 402s — so every
 * premium surface should detect that 402 and render this instead of a generic
 * "failed to load" error or a misleading empty state.
 */
export function PremiumRequiredAlert({ feature }: { feature: string }) {
  return (
    <Alert
      color="blue"
      icon={<IconSparkles size={16} />}
      title={`${feature} is a Premium feature`}
    >
      This isn’t included in your current plan. Upgrade to Premium (or ask your
      organization admin) to unlock it.
    </Alert>
  );
}
